import PropTypes from "prop-types";

export const UserAttributes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export const UserItem = PropTypes.shape(UserAttributes);
